import React, { useState, useEffect } from 'react';
import wedding1 from '../../../img/wedding1.jpg';
import wedding2 from '../../../img/wedding2.jpg';
import wedding3 from '../../../img/wedding3.jpg';
import wedding4 from '../../../img/wedding4.jpg';
import LazyImage from '../../../shared/components/ui/media/LazyImage';

const images = [
  { src: wedding1, alt: '結婚式での幸せな瞬間' },
  { src: wedding2, alt: '感動的な結婚式の一場面' },
  { src: wedding3, alt: '美しい結婚式の思い出' },
  { src: wedding4, alt: '結婚式での特別な時間' }
];

const Header: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <header className="page-header">
      <div className="header-image-slider">
        {images.map((image, index) => (
          <div 
            key={index} 
            className={`fade-slide ${index === currentIndex ? 'active' : ''}`}
          >
            <LazyImage
              src={image.src}
              alt={image.alt}
              className="header-image"
            />
          </div>
        ))}
        
        <div className="header-overlay">
          <div className="header-text">
            <h1 className="header-title">Photo Memorial</h1>
            <p className="header-subtitle">その一枚が、<br />祝福になる。</p>
          </div>
        </div>
      </div>
      <div className="header-bottom-band"></div>
    </header>
  );
};

export default Header;